import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/depots/depots.scss";
import { Button, FormControl } from "react-bootstrap";
import ZoneTable from "./zoneTable";
import axios from "axios";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import { Link } from "react-router-dom";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import queryString from "query-string";
import { downloadCSVFile } from "../../api/apiClient";

class Zones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            depotList: [],
            filteredDepotList: [],
            searchText: "",
            customerStatusFilter: "active",
            sortKey: "customerName",
            sortDirection: "asc",
        };
    }
    async componentDidMount() {
        this.props.setLoadingPageAction(true);

        const values = queryString.parse(this.props.location.search);
        console.log("customerID", values.customerId);
        var urlAll = "";
        if (values.customerId) {
            this.customerId = values.customerId;
            let query = encodeQueryData(this.setCustomersQueryObject());
            urlAll = `${apiHost}/api/POI/GetAllPOIs?${query}`;
            this.getZones(urlAll);
        } else {
            let query = encodeQueryData(this.setCustomersQueryObject());
            urlAll = `${apiHost}/api/POI/GetAllPOIs?${query}`;
            this.getZones(urlAll);
        }
    }

    setCustomersQueryObject = () => {
        let data = {};
        data.SearchString = this.searchText;
        data.customerId = this.customerId;
        data.PageSize = this.pageSize;
        data.PageNumber = this.pageKey;
        data.SortDirection = this.sortDirection;
        data.SortString = this.sortString;
        return data;
    };

    getZones = async (url) => {
        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            this.setState({ depotList: response.data, filteredDepotList: response.data });
            this.props.setLoadingPageAction(false);
        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`);
            }
            this.props.setLoadingPageAction(false);

            console.log(`😱 Axios request failed: ${e}`);
        }
    };

    downloadTemplate = (e) => {
        const csvTemplate = [{
            Name: "text",
            Description: "text",
            Address: "text",
            Duration: "number",
            Status: "text (Active/Disable)"
        }];
        downloadCSVFile(csvTemplate, "poi", "csv","template","");
    };

    handleSearch = (searchText) => {
        const search = searchText.trim().toLowerCase();
        const filteredDepotList = search
            ? this.state.depotList.filter((zone) => {
                const searchableText = [
                    zone.name,
                    zone.customerName,
                    zone.customerStatus,
                    zone.description,
                    zone.address,
                    zone.private ? "Private" : "Public",
                    zone.status === 1 ? "Active" : "Disabled",
                    zone.dbUpdated,
                ].join(" ").toLowerCase();

                return searchableText.includes(search);
            })
            : this.state.depotList;

        this.setState({ searchText, filteredDepotList });
    };

    handleSort = (sortKey) => {
        this.setState((prevState) => ({
            sortKey,
            sortDirection:
                prevState.sortKey === sortKey && prevState.sortDirection === "asc"
                    ? "desc"
                    : "asc",
        }));
    };

    handleCustomerStatusFilter = (customerStatusFilter) => {
        this.setState({ customerStatusFilter });
    };

    getCustomerStatus = (zone) => {
        return (zone.customerStatus || "Active").toString().toLowerCase();
    };

    getStatusFilteredZones = () => {
        const { filteredDepotList, customerStatusFilter } = this.state;

        if (customerStatusFilter === "all") {
            return filteredDepotList;
        }

        return filteredDepotList.filter((zone) => this.getCustomerStatus(zone) === customerStatusFilter);
    };

    getStatusCounts = () => {
        const { filteredDepotList } = this.state;

        return filteredDepotList.reduce(
            (counts, zone) => {
                const status = this.getCustomerStatus(zone);

                counts.all += 1;

                if (status === "active") {
                    counts.active += 1;
                }

                if (status === "disabled" || status === "disable") {
                    counts.disabled += 1;
                }

                return counts;
            },
            { all: 0, active: 0, disabled: 0 }
        );
    };

    getSortValue = (zone, sortKey) => {
        if (sortKey === "dbUpdated") {
            return zone.dbUpdated ? new Date(zone.dbUpdated).getTime() : 0;
        }

        if (sortKey === "status") {
            return zone.status || 0;
        }

        if (sortKey === "private") {
            return zone.private ? 1 : 0;
        }

        return (zone[sortKey] || "").toString().toLowerCase();
    };

    getDisplayZones = () => {
        const { sortKey, sortDirection } = this.state;
        const direction = sortDirection === "asc" ? 1 : -1;

        return [...this.getStatusFilteredZones()].sort((a, b) => {
            const aValue = this.getSortValue(a, sortKey);
            const bValue = this.getSortValue(b, sortKey);

            if (aValue < bValue) {
                return -1 * direction;
            }

            if (aValue > bValue) {
                return 1 * direction;
            }

            return 0;
        });
    };

    render() {
        const { searchText, customerStatusFilter, sortKey, sortDirection } = this.state;
        const values = queryString.parse(this.props.location.search);
        const displayZones = this.getDisplayZones();
        const statusCounts = this.getStatusCounts();
        const customerStatusFilters = [
            { key: "all", label: "All", count: statusCounts.all },
            { key: "active", label: "Active", count: statusCounts.active },
            { key: "disabled", label: "Disabled", count: statusCounts.disabled },
        ];

        return (
            <React.Fragment>
                <Layout>
                    <Helmet>
                        <title>POI Zones</title>
                    </Helmet>
                    <div className="contentBody">
                        <div className="contentWrapper depot-page zone-page">
                            <div className="depot-page-header">
                                <div>
                                    <h2>POI Zones</h2>
                                    <p>Manage customer POI zones, addresses and alert areas.</p>
                                    {values.customerId && (
                                        <a
                                            className="depot-filter-pill"
                                            onClick={() => localStorage.removeItem("customer")}
                                            href="/zones"
                                        >
                                            <i className="fa fa-times"></i>
                                            {values.customerName}
                                        </a>
                                    )}
                                </div>
                                <div className="zone-page-actions">
                                <Link to="/createZone">
                                    <Button className="depot-create-button" variant="primary">
                                        <i className="fa fa-plus"></i>
                                        Create new
                                    </Button>
                                </Link>
                                <Link to="/uploadCsv" className="uploadCsv">
                                    <Button className="zone-secondary-button" variant="primary">
                                        <i className="fa fa-upload"></i>
                                        Import CSV
                                    </Button>
                                </Link>
                                <Button className="zone-secondary-button" variant="primary" onClick={(e) => this.downloadTemplate(e)}>
                                    <i className="fa fa-download"></i>
                                    Download Template
                                </Button>
                                </div>
                            </div>

                            <div className="depot-toolbar">
                                <div className="depot-search">
                                    <i className="fa fa-search"></i>
                                    <FormControl
                                        aria-label="Search POI zones"
                                        onChange={(e) => this.handleSearch(e.target.value)}
                                        placeholder="Search POI zones, customers, addresses, descriptions or status"
                                        value={searchText}
                                    />
                                    {searchText && (
                                        <button onClick={() => this.handleSearch("")} type="button">
                                            <i className="fa fa-times"></i>
                                        </button>
                                    )}
                                </div>
                                <div className="depot-status-filter" aria-label="Active customer filter">
                                    <span>Active customer filter</span>
                                    <div>
                                        {customerStatusFilters.map((filter) => (
                                            <button
                                                className={customerStatusFilter === filter.key ? "active" : ""}
                                                key={filter.key}
                                                onClick={() => this.handleCustomerStatusFilter(filter.key)}
                                                type="button"
                                            >
                                                {filter.label}
                                                <strong>{filter.count}</strong>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="customers depot-table-shell">
                                <ZoneTable
                                    depots={displayZones}
                                    onSort={this.handleSort}
                                    sortDirection={sortDirection}
                                    sortKey={sortKey}
                                />
                            </div>
                        </div>
                    </div>
                </Layout>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.loading,
});
const mapDispatchToProps = {
    setLoadingPageAction: setLoadingPage,
    setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Zones);
